<template>
    <kt-panel>
        <kt-panel-body>
            <form @submit.prevent class="kt-form" id="marketer_wage">
                <kt-row v-for="wage in wages" :key="wage.id" lg="12" md="12" xs="12" class="align-items-center p-3 p-sm-0 mt-4 mt-sm-0 rowMe">
                    <input type="text" disabled :value="wage.period_number" class="text-center border-0 bg-white d-none d-sm-block" style="width:25px">
                    <kt-col class="col-12 col-sm-4">
                        <kt-form-section>
                            <kt-form-group >
                                <kt-form-label for="period-duration-days">
                                    {{ $t('marketing.marketing_wage.period_duration') }}
                                </kt-form-label>
                                <kt-form-control
                                        type="number"
                                        name="period-duration-days"
                                        id="period-duration-days"
                                        v-model="wage.period_duration_days"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-form-section>
                    </kt-col>
                    <kt-col class="col-12 col-sm-4">
                        <kt-form-section>
                            <kt-form-group >
                                <kt-form-label for="wage">
                                    {{ $t('marketing.marketing_wage.wage') }}
                                </kt-form-label>
                                <kt-form-control
                                        type="text"
                                        placeholder=""
                                        name="wage"
                                        id="wage"
                                        max="100"
                                        v-model="wage.period_wage"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-form-section>
                    </kt-col>
                    <input style="width:15px;height:15px" :checked="wage.infinite" :ref="`infinite${wage.id}`" type="radio" name="infinite" :title="$t('marketing.marketing_wage.infininte')">
                    <div class="d-flex flex-nowrap">
                        <button @click="deleteItem(wage)" title="حذف" type="button" class=" btn btn-label-danger trash-btn ml-3"><i class="la la-trash-o"></i></button>
                        <button :id="`update-wage${wage.id}`" type="button" @click="updateItem(wage)" style="cursor:pointer" class="btn btn-info ml-2" v-text="$t('marketing.marketing_wage.update')"></button>
                    </div>
                </kt-row>
                <hr class="my-5" v-if="newWages.length > 0 && wages.length > 0">
                <kt-row v-for="wage in newWages" :key="wage.id" lg="12" md="12" xs="12" class="align-items-center  p-3 p-sm-0 mt-4 mt-sm-0 rowMe">
                    <input type="text" disabled :value="wage.period_number" class="text-center border-0 bg-white" style="width:25px">
                    <kt-col class="col-12 col-sm-4">
                        <kt-form-section>
                            <kt-form-group >
                                <kt-form-label for="period-duration-days">
                                    {{ $t('marketing.marketing_wage.period_duration')}}
                                </kt-form-label>
                                <kt-form-control
                                        type="number"
                                        name="period-duration-days"
                                        id="period-duration-days"
                                        v-model="wage.period_duration_days"
                                        max="100"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-form-section>
                    </kt-col>
                    <kt-col class="col-12 col-sm-4">
                        <kt-form-section>
                            <kt-form-group >
                                <kt-form-label for="wage">
                                    {{ $t('marketing.marketing_wage.wage') }}
                                </kt-form-label>
                                <kt-form-control
                                        type="text"
                                        placeholder=""
                                        name="wage"
                                        id="wage"
                                        max="100"
                                        v-model="wage.period_wage"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-form-section>
                    </kt-col>

            <input class="" style="width:15px;height:15px" :ref="`infinite`+ wage.id" type="radio" name="infinite" :title="$t('marketing.marketing_wage.infininte')">

                    <div class="d-flex flex-nowrap">
                        <button  @click="deleteNewItem(wage)" title="حذف" type="button" class=" btn btn-label-danger trash-btn ml-3"><i class="la la-trash-o"></i></button>
                        <button @click="registerNewItem(wage)" type="button" style="cursor:pointer" class="btn btn-info ml-2" :id="`register-new-wage${wage.id}`" v-text="$t('marketing.marketing_wage.register')"></button>
                    </div>
                </kt-row>
                <div v-if="wages.length> 0 || newWages.length > 0" class="mt-3 mt-sm-0">
                    <ul class="p-0 m-0">
                        <li class="ml-2 ml-sm-5" v-text="$t('marketing.marketing_wage.message_info')"> </li>
                    </ul>
                </div>
                <kt-row>
                    <button type="button" @click="addWage()" class="btn btn-outline-success mt-3 ml-3" v-text="$t('marketing.marketing_wage.add_wage')"></button>
                </kt-row>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
    import $ from 'jquery'
    import { marketingService } from "@/common/api.service"
    import { KTApp } from '@/plugins/core/app'
    export default{
        data(){
        return{
            wages: [],
            newWages: [],
            tab: this.$route.params.tab || "pardakhtyari",
        };
    },
    created(){
        this.fetchWages();
    },
    watch: {
        "$route.params.tab": {
            handler(newTab) {
                this.tab = newTab;
                this.fetchWages();
            },
            immediate: true,
        },
    },
    methods: {
        getServiceMethods() {
            const methods = {
                pardakhtyari: {
                    getWages: marketingService.getWages,
                    deleteWage: marketingService.deleteWage,
                    updateWage: marketingService.updateWage,
                    createWage: marketingService.createWage,
                },
                starshop: {
                    getWages: marketingService.getStarshopWages,
                    deleteWage: marketingService.deleteStarshopWage,
                    updateWage: marketingService.updateStarshopWage,
                    createWage: marketingService.createStarshopWage,
                },
            };
            return methods[this.tab] || methods.pardakhtyari;
        },

        fetchWages() {
            const { getWages } = this.getServiceMethods();
            getWages(this.$route.params.user_id)
                .then((res) => {
                    this.wages = res.data.data;
                })
                .catch((e) => {
                    throw new Error(e);
                });
        },

        deleteItem(wage) {
            const el = $("#marketer_wage");
            const { deleteWage } = this.getServiceMethods();
            deleteWage(wage.id)
                .then((res) => {
                    this.fetchWages();
                    this.showMsg(el, "success", res.data.message);
                })
                .catch((e) => {
                    this.showMsg(el, "danger", e.response.message);
                });
        },

        updateItem(wage) {
            const el = $("#marketer_wage");
            const btn = $(`#update-wage${wage.id}`);
            const { updateWage } = this.getServiceMethods();
            wage.period_wage = String(wage.period_wage).replace(/,/g, "");
            wage.user_id = this.$route.params.user_id;
            wage.infinite = this.$refs[`infinite${wage.id}`][0].checked || false;

            KTApp.progress(btn);
            updateWage(wage)
                .then((res) => {
                    KTApp.unprogress(btn);
                    this.fetchWages();
                    this.showMsg(el, "success", res.data.message);
                })
                .catch((e) => {
                    KTApp.unprogress(btn);
                    this.showMsg(el, "danger", e.response.message);
                });
        },

        registerNewItem(wage) {
            const el = $("#marketer_wage");
            const btn = $(`#register-new-wage${wage.id}`);
            const { createWage } = this.getServiceMethods();
            wage.user_id = this.$route.params.user_id;
            wage.infinite = this.$refs[`infinite${wage.id}`][0].checked || false;

            KTApp.progress(btn);
            createWage(wage)
                .then((res) => {
                    KTApp.unprogress(btn);
                    this.newWages = [];
                    this.fetchWages();
                    this.showMsg(el, "success", res.data.message);
                })
                .catch((e) => {
                    KTApp.unprogress(btn);
                    this.showMsg(el, "danger", e.response.message);
                });
        },

        addWage() {
            this.newWages.push({
                period_duration_days: "",
                infinite: false,
                period_wage: "",
            });
        },

        deleteNewItem(wage) {
            const index = this.newWages.indexOf(wage);
            if (index > -1) this.newWages.splice(index, 1);
        },
    }
}

</script>

<style scoped>
@media (max-width:576px) {
    .rowMe{
        border:1px solid whitesmoke;
    }
}
</style>